import ModalFormButton from "../modal-form-button";

export default function CallBackButton() {
  return (
    <ModalFormButton
      buttonText="заказать звонок"
      buttonClassName="call-back-button"
      modalTitle="Заказать звонок"
    />
  );
}
